import { type ReactElement } from 'react';
import { DivSkeleton, Flex, Div } from '@fastnorth/kraken/components/layout';
import { useApp } from '../../hooks/AppProvider';
import DisplayMessages from '../../components/display-messages/DisplayMessages';
import { getDisplayMessages } from '../../layout/utils/getDisplayMessages';
import useAppLocation from '../../hooks/useAppLocation.ts';
import { TableSkeleton } from '@fastnorth/kraken/components/table';
import { useSubEvent } from '../../hooks/SubEventProvider.tsx';

type LeaderboardSkeletonProps = {
  bypassDisplayMessages?: boolean;
  showTableControls?: boolean;
};

const LeaderboardSkeleton = ({
  bypassDisplayMessages = false,
  showTableControls = true,
}: LeaderboardSkeletonProps): ReactElement => {
  const [{ event }] = useApp();
  const { subEvent } = useSubEvent();
  const locationState = useAppLocation();

  // Get display messages for leaderboard
  const filteredDisplayMessages = getDisplayMessages(event!, subEvent || null, locationState);
  const showDisplayMessages = !bypassDisplayMessages && filteredDisplayMessages.length > 0;

  const numRows = 8;
  const numCols = 10;

  return (
    <Flex className={'flex-col gap-6 h-auto'} data-testid={'leaderboard-skeleton'}>
      {/* Display messages for leaderboard */}
      {showDisplayMessages && (
        <Div className="w-full max-w-[975px] mx-auto mb-6">
          <DisplayMessages displayMessages={filteredDisplayMessages} />
        </Div>
      )}

      {showTableControls && (
        <Flex className={'gap-7 justify-between h-full'}>
          <DivSkeleton className={'w-1/3 rounded-2 h-[40px]'} />
          <DivSkeleton className={'w-2/3 rounded-2 h-[40px]'} />
        </Flex>
      )}
      <TableSkeleton rows={numRows} cols={numCols} />
    </Flex>
  );
};

export default LeaderboardSkeleton;
